export const BRAND_GRADIENT =
  'linear-gradient(135deg, #56BEDB 0%, #203097 100%)';

export const BRAND_GRADIENT_HOVER =
  'linear-gradient(135deg, #45A8C5 0%, #1A2680 100%)';
